import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex items-center gap-[6px]'
  },
  variants: {},
  defaultVariants: {}
});
